import "../css/swo.css"; // Import CSS to be processed by Webpack
import "@bookklik/senangstart-icons"; // Icons are bundled statically so no asynchronous chunk needs to ship alongside the main bundle
import SWO from "./swo";

export type { SWOOptions } from "./swo";

// Auto-initialize
function initializeSWO() {
  document.querySelectorAll("[data-swo]").forEach((el) => {
    const htmlEl = el as HTMLElement;
    if (!htmlEl.isConnected) return;
    if (!htmlEl.swoInstance) {
      try {
        htmlEl.swoInstance = new SWO(htmlEl, {});
      } catch (error) {
        console.error("SWO: Unable to initialize target:", htmlEl, error);
      }
    }
  });
}

if (typeof window !== "undefined") {
  if (
    document.readyState === "complete" ||
    (document.readyState !== "loading")
  ) {
    initializeSWO();
  } else {
    document.addEventListener("DOMContentLoaded", initializeSWO, { once: true });
  }
}

export default SWO;
